import { Card, CardContent, Typography, Box, Skeleton } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { CHART_COLORS, formatCurrency, formatNumber } from "../constants";

interface TopProductsChartProps {
  data: any;
  loading: boolean;
}

const TopProductsChart = ({ data, loading }: TopProductsChartProps) => {
  if (loading) {
    return (
      <Card sx={{ height: "100%", borderRadius: 2, boxShadow: "0 1px 3px 0 rgba(0,0,0,.1)" }}>
        <CardContent sx={{ p: 2.5 }}>
          <Skeleton width="40%" height={24} />
          <Skeleton width="100%" height={280} sx={{ mt: 2 }} />
        </CardContent>
      </Card>
    );
  }

  const chartData = (data?.byQuantity || []).map((item: any) => ({
    name: item.productName?.length > 15 ? item.productName.slice(0, 15) + "..." : item.productName,
    fullName: item.productName,
    quantity: item.totalQuantity,
    revenue: item.totalRevenue,
  }));

  return (
    <Card sx={{ height: "100%", borderRadius: 2, boxShadow: "0 1px 3px 0 rgba(0,0,0,.1)" }}>
      <CardContent sx={{ p: 2.5 }}>
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
          Top Products by Sales
        </Typography>
        {chartData.length > 0 ? (
          <ResponsiveContainer width="100%" height={280}>
            <BarChart
              data={chartData}
              layout="vertical"
              margin={{ top: 5, right: 20, left: 5, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" horizontal={false} />
              <XAxis type="number" tick={{ fontSize: 11 }} />
              <YAxis
                type="category"
                dataKey="name"
                width={110}
                tick={{ fontSize: 10 }}
              />
              <Tooltip
                formatter={(value: any, name: any) => [
                  name === "quantity" ? formatNumber(value) : formatCurrency(value),
                  name === "quantity" ? "Units Sold" : "Revenue",
                ]}
                labelFormatter={(_label: any, payload: any) =>
                  payload?.[0]?.payload?.fullName || _label
                }
                contentStyle={{ borderRadius: 8, fontSize: 13 }}
              />
              <Bar dataKey="quantity" fill={CHART_COLORS.primary} radius={[0, 6, 6, 0]} barSize={18} />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <Box sx={{ height: 280, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Typography color="text.secondary">No product data</Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default TopProductsChart;
